import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import logo from "../loaderWhite.png";
const useStyles = makeStyles(theme => ({
  root: {
    background:
      "radial-gradient(circle, rgba(232,98,104,1) 0%, rgba(204,43,51,1) 50%, rgba(117,7,13,1) 99%)",
    minWidth: "100%",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  logo: {
    width: 231,
    margin: "0 auto"
  },
  icon: {
    width: 100,
    margin: "0 auto",
    marginTop: 40,
    color: "white"
  }
}));

const LoadingScreen = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <img src={logo} className={classes.logo} alt="logo" />
      <CircularProgress className={classes.icon} />
    </div>
  );
};
export default LoadingScreen;
